<template>
  <div
    class="fixed inset-x-0 top-[56px] md:absolute md:bottom-auto md:top-full md:-mt-48"
    :class="{
      'bottom-0 md:bottom-auto': isOpen,
    }"
    tabindex="-1"
  >
    <Transition
      enter-active-class="ease-out duration-100 md:duration-300 delay-[50ms] md:delay-0"
      enter-from-class="opacity-0 md:opacity-100 md:[clip-path:inset(0_0_100%)]"
      enter-to-class="opacity-100 md:[clip-path:inset(0_0_0%)]"
      leave-active-class="ease-in duration-0 md:duration-100"
      leave-from-class="opacity-100 md:[clip-path:inset(0_0_0%)]"
      leave-to-class="opacity-0 md:opacity-100 md:[clip-path:inset(0_0_100%)]"
    >
      <div
        v-show="isOpen"
        ref="dropdown"
        class="bg-surface-default-low border-static-default-low inset-0 h-full w-full grow overflow-y-auto overscroll-y-contain border-t md:absolute md:inset-auto md:h-auto"
        data-test="search-bar-dropdown"
        :tabindex="isTouchDevice ? 0 : undefined"
      >
        <slot />
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { useTemplateRef, watch } from 'vue'

import { type Fn, useEventListener } from '@vueuse/core'

const props = defineProps<{
  isOpen?: boolean
  isTouchDevice?: boolean
}>()

const dropdownRef = useTemplateRef('dropdown')

if (import.meta.client) {
  let stopTouchMoveListener: Fn

  watch(
    () => props.isOpen,
    (isOpen) => {
      if (props.isTouchDevice) {
        if (isOpen) {
          stopTouchMoveListener = useEventListener(
            dropdownRef.value,
            'touchmove',
            () => {
              dropdownRef.value?.focus()
            },
          )
        } else {
          stopTouchMoveListener?.()
        }
      }
    },
  )
}
</script>
